<homey-page-title title="Subscription"/>
@let userData = user();

@if (userData !== undefined) {
  <p class="mb-6">Your subscription is currently
    @switch (userData.simplifiedPaymentInfo.status) {
      @case ('trialing') {
        <span class="text-blue-400">Trialing</span>
        @if (userData.simplifiedPaymentInfo.trialEndDate) {
          <span class="text-muted-color">
            (Trial ends on {{ userData.simplifiedPaymentInfo.trialEndDate | date }})
          </span>
        }
      }
      @case ('active') {
        <span class="text-green-600">Active</span>
      }
      @case ('past-due') {
        <span class="text-red-600 font-medium">Past due</span>
      }
      @case ('canceled') {
        <span class="text-red-600">Not active</span>
      }
      @case ('canceling') {
        <span class="text-orange-600">Active</span>
        <span class="text-muted-color">
            @if (userData.simplifiedPaymentInfo.trial) {
              (Cancels at the end of your free trial)
            }
          @if (userData.simplifiedPaymentInfo.cancelsAt) {
            (Cancels on {{ userData.simplifiedPaymentInfo.cancelsAt | date }})
          } @else {
            (Cancels at the end of your current billing cycle)
          }
          </span>
      }
    }
  </p>
  <homey-submit-button submitButtonLabel="View subscription details" severity="secondary"
                       [submitFunction]="submit"></homey-submit-button>

  @if (userData.paymentStatus === 'paid' && userData.paymentInfo.type === 'stripe' && !userData.paymentInfo.cancellationDate && !userData.paymentInfo.manuallyCancelled) {
    <p-button severity="secondary" class="mt-4" styleClass="w-full" (onClick)="onCancelClick()">
      Cancel subscription
    </p-button>
  }

  <homey-page-subtitle-layout class="mt-16">
    What happens if I unsubscribe?
  </homey-page-subtitle-layout>
  <p>Your submitted applications will remain valid, and we'll continue to update you on their results. However, you
    won't be able to apply to any new lotteries.</p>
  @if (userData.simplifiedPaymentInfo.status === 'canceled') {
    <homey-page-subtitle-layout class="mt-8">
      What happens when I resubscribe?
    </homey-page-subtitle-layout>
    <p>You will be able to apply to any new lottery you qualify for - just like before.</p>
  }

  <p-dialog styleClass="max-w-md" header="Want to cancel?" [(visible)]="cancelOpen"
            [modal]="true">
    <p class="mb-4">
      Mind telling us why you're cancelling? Your feedback helps us improve Homey.
    </p>

    <p class="text-muted-color">Reason</p>
    <form [formGroup]="cancelForm">
      @for (option of cancelReasonOptions; track $index) {
        <div class="mb-1">
          <p-radio-button [inputId]="option" formControlName="reason" [value]="option"></p-radio-button>
          <label [for]="option" class="ml-2">{{ reasonLabels[option] }}</label>
        </div>
      }
      <p class="mt-4">
        <label for="details" class="text-muted-color">Details</label>
      </p>
      <textarea class="w-full" id="details" rows="5" cols="30" pTextarea formControlName="details"
                placeholder="Please give us your thoughts, we look at everything."></textarea>
    </form>

    <homey-form-buttons
      class="mt-6"
      [submitFunction]="submitCancelSubscription"
      [small]="true"
      [buttons]="[{
        label: 'Go back',
        value: 'back',
        severity: 'primary'
      },
      {
        label: 'Confirm cancellation',
        value: 'confirm',
        severity: 'secondary',
        disabled: cancelForm.invalid
      }
      ]"/>
  </p-dialog>

  <p-dialog styleClass="max-w-md"
            [header]="cancelForm.value.reason === 'bug' ? ohWereSorry : '🧡 We get it — money is tight'"
            [(visible)]="subscriptionDiscountDialogOpen"
            [modal]="true" [closable]="false">
    @let discount = stayHomeyDiscount();
    @if (cancelForm.value.reason === 'bug') {
      <p>
        Oh no! We're really sorry to hear that. We strive to provide the best experience possible, please contact us
        about what exactly happened so we can fix it. </p><p class="mt-2"> To make things a little easier, here's <span
        class="text-orange-gradient font-medium">{{ discount.description }}</span>.
      </p>
    } @else {
      <p>
        We completely understand that budgets can be tough right now. To make things a little easier, here's <span
        class="text-orange-gradient font-medium">{{ discount.description }}</span>.
        @if (userData.paymentInfo.type === 'stripe') {
          From now on, Homey will only cost {{ (((userData.paymentInfo.mainSubscriptionPrice - userData.paymentInfo.mainSubscriptionPrice * discount.discountPercent / 100) | floor) / 100) | currency }} per {{ userData.paymentInfo.interval }}.
        }
      </p>
    }
    <div class="flex flex-row justify-center py-14">
      <img src="/assets/gift.png" class="size-32" alt="">
    </div>
    <homey-form-buttons
      class="mt-6"
      [submitFunction]="submitDiscount"
      [small]="true"
      [buttons]="[{
        label: 'Cancel anyway',
        value: 'cancel',
        severity: 'secondary'
      }, {
        label: discount.buttonLabel,
        value: 'discount',
        severity: 'primary'
      }
      ]"/>
  </p-dialog>
}
